exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".testbtn{height:30px;cursor:pointer;background:#777}.test li{border:1px solid #ccc;margin:2px 0}.test li.active{border:1px solid #c00}", "", {"version":3,"sources":["/project/slimvue-website/website/components/package/Index.vue"],"names":[],"mappings":"AACA,SAAW,YAAa,AAAC,eAAgB,AAAC,eAAiB,CAC1D,AACD,SAAW,sBAAuB,AAAC,YAAa,CAC/C,AACD,gBAAkB,qBAAuB,CACxC","file":"Index.vue","sourcesContent":["\n.testbtn { height: 30px; cursor: pointer; background: #777;\n}\n.test li { border: 1px solid #ccc; margin: 2px 0\n}\n.test li.active { border: 1px solid #c00;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e5e1551","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./website/components/package/Index.vue
// module id = in5c
// module chunks = 0